import * as Long from "long";
import { from } from "rxjs";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../../selectors/selectNotEnoughResources";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingUpgradeNotEnoughResourceStandard = function (action, state$) {
    var state = state$.value;
    var upgradeInfo = selectBuildingUpgradeInfo(action.building);
    var standardCost = upgradeInfo.nextStage.standard.cost;
    var standardCostItem = standardCost.map(function (item) { return ({
        amount: Long.fromValue(item.amount),
        typeId: item.resourceId,
    }); });
    var missingResources = selectNotEnoughResourcesMissingResources(state, standardCostItem);
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: missingResources,
                missingType: IdMissingResourceTypes.Resources,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingUpgradeNotEnoughResourceStandard.ts
// module id = 2080
// module chunks = 3